import React, { useContext } from 'react';
import LoginHeader from '../../components/Headers/LoginHeader';
import LoginFooter from '../../components/Footers/LoginFooter';
import OpportunitySingle from '../../components/OpportunitySingle';
import { UserContext } from '../../context/User';
import AdminHeader from '../../components/Headers/AdminHeader';

const OpportunitySinglePage = () => {
  const { user } = useContext(UserContext);
  const role = user && user.roles && user.roles[0].role_description;

  return (
    <>  
      {role === "admin" ? <AdminHeader /> : <LoginHeader />}
      <main>
        <OpportunitySingle />
      </main>
      <LoginFooter />
    </>
  )
}

export default OpportunitySinglePage;